import React, { useState } from 'react';

const TreeTableSubRow = ({ langLocal, translate, data, depth, setOpen, setzone_id, setOpen1,checkedItem,setCheckedItem }) => {
    const [expandedRows, setExpandedRows] = useState({});

    const toggleExpanded = (id) => {
        setExpandedRows(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));
    };

    const handleCheckboxChange = (id) => {
        setCheckedItem(id);
        setzone_id(id)
    };

    return (
        <>
            {
                data?.map((item) => (
                    <React.Fragment key={item.id}>
                        <tr dir={langLocal === 'ar' ? "rtl" : "ltr"}>
                            <td style={{ width: "90px", textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }}>
                                <input type="radio" checked={checkedItem === item.id} onChange={() => handleCheckboxChange(item.id)} />
                            </td>
                            <td>
                                <div style={langLocal === 'ar' ? { marginRight: `${depth * 20}px`, cursor: 'pointer' } :
                                    { marginLeft: `${depth * 20}px`, cursor: 'pointer' }}
                                    onClick={(e) => { e.stopPropagation(); toggleExpanded(item.id) }}>
                                    <div className='d-flex'>
                                        {item.name}
                                        {item.sub_zones && item.sub_zones.length > 0 && (
                                            <div onClick={(e) => { e.stopPropagation(); toggleExpanded(item.id) }} style={{ cursor: 'pointer' }}>
                                                <i style={langLocal === 'ar' ? { marginRight: "10px" } :
                                                    { marginLeft: "10px" }}
                                                    className={`fas fa-caret-${expandedRows[item.id] ? 'down' : 'right'}`}></i>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </td>
                            <td style={{ textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }}>
                                <span>{item.symbol}</span>
                            </td>
                        </tr>
                        {expandedRows[item.id] && item.sub_zones && item.sub_zones.length > 0 && (
                            <>
                                <TreeTableSubRow checkedItem={checkedItem} setCheckedItem={setCheckedItem} langLocal={langLocal} translate={translate} setOpen1={setOpen1} data={item.sub_zones} depth={depth + 1} setOpen={setOpen} setzone_id={setzone_id} />
                            </>
                        )}
                    </React.Fragment>
                ))
            }
        </>
    );
};
const TreeTableRow = ({ langLocal, translate, data, depth, setOpen, setzone_id, setOpen1 }) => {
    const [expandedRows, setExpandedRows] = useState({});
    const [checkedItem, setCheckedItem] = useState(null);

    const toggleExpanded = (id) => {
        setExpandedRows(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));
    };

    const handleCheckboxChange = (id) => {
        setCheckedItem(id);
        setzone_id(id)
    };

    return (
        <>
            {data.map(itemm => (
                itemm?.zones?.map((item) => (
                    <React.Fragment key={item.id}>
                        <tr dir={langLocal === 'ar' ? "rtl" : "ltr"}>
                            <td style={{ width: "90px", textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }}>
                                <input type="radio" checked={checkedItem === item.id} onChange={() => handleCheckboxChange(item.id)} />
                            </td>
                            <td>
                                <div style={langLocal === 'ar' ? { marginRight: `${depth * 20}px`, cursor: 'pointer' } :
                                    { marginLeft: `${depth * 20}px`, cursor: 'pointer' }}
                                    onClick={(e) => { e.stopPropagation(); toggleExpanded(item.id) }}>
                                    <div className='d-flex'>
                                        {item.name}
                                        {item.sub_zones && item.sub_zones.length > 0 && (
                                            <div onClick={(e) => { e.stopPropagation(); toggleExpanded(item.id) }} style={{ cursor: 'pointer' }}>
                                                <i style={langLocal === 'ar' ? { marginRight: "10px" } :
                                                    { marginLeft: "10px" }}
                                                    className={`fas fa-caret-${expandedRows[item.id] ? 'down' : 'right'}`}></i>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </td>
                            <td style={{ textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }}>
                                <span>{item.symbol}</span>
                            </td>
                        </tr>
                        {expandedRows[item.id] && item.sub_zones && item.sub_zones.length > 0 && (
                            <>
                                <TreeTableSubRow checkedItem={checkedItem} setCheckedItem={setCheckedItem} langLocal={langLocal} translate={translate} setOpen1={setOpen1} data={item.sub_zones} depth={depth + 1} setOpen={setOpen} setzone_id={setzone_id} />
                            </>
                        )}
                    </React.Fragment>
                ))
            ))}
        </>
    );
};


function CustomTreeTableAssign({ langLocal, translate, columns, data, open, setOpen, setzone_id, setOpen1 }) {
    return (
        <table className="tree-table">

            <thead >
                <tr >
                    {columns.map((column, index) => (
                        <th style={{ textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }} key={index}>{column}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {
                    data?.length > 0 ? <TreeTableRow langLocal={langLocal} translate={translate} setOpen={setOpen} setzone_id={setzone_id} data={data} depth={0} setOpen1={setOpen1} /> :
                        <div style={{ position: "absolute", width: "100%", height: "150px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "white" }} >There are no data</div>
                }

            </tbody>
        </table>
    );
}

export default CustomTreeTableAssign;
